<template>
  <div id="app">
    <VirtualOpenDay/>
  </div>
</template>

<script>
import VirtualOpenDay from "./views/VirtualOpenDay"

export default {
  name: 'YouTubeVideoModal',
  components: {
    VirtualOpenDay
  },
}
</script>

<style lang="scss">
#app {
  font-family: $font-family-primary;
  font-size: $font-size-base;
  line-height: $font-line-height;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: $color-text;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
